import { Trend } from "@tandemdiabetes/sugarmate-api-react-client"
import styles from "./CurrentReading.module.scss"
import { TrendIcon } from "src/components"
import {
  useReadableGlucoseUnit,
  useReadableGlucoseValue,
  useReadableTime,
} from "src/hooks"
import type { Reading } from "src/types"

interface Props {
  reading: Reading;
}

export function CurrentReading(props: Props) {
  const { reading } = props

  const unit = useReadableGlucoseUnit()
  const value = useReadableGlucoseValue(reading.glucose.mg_dl)
  const time = useReadableTime(reading.startedAt)

  return (
    <div className={styles.container}>
      <div className={styles.reading}>
        <div
          className={styles.readingTime}
          id="menu-cgm-reading-time"
        >
          {time}
        </div>
        <div
          className={styles.readingValue}
          id="menu-cgm-reading-value"
        >
          {value}
        </div>
        <div
          className={styles.readingUnit}
          id="menu-cgm-reading-units"
        >
          {unit}
        </div>
      </div>
      <TrendIcon
        className={styles.trendIcon}
        id="menu-cgm-trend-arrow"
        trend={reading.glucose.trend ?? Trend.None}
      />
    </div>
  )
}
